"use client";

import GenericSubstantiveProcedures from "../../substantive-procedures/GenericSubstantiveProcedures";

const WORKSPACE_NAME = "Biological Assets other than Bearer Plants";

interface BAPBSubstantiveProceduresProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

export default function BAPBSubstantiveProcedures({ onBack, setActiveSection }: BAPBSubstantiveProceduresProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
